import React, { useEffect, useRef, useState } from "react";
import styles from '../index.module.css';
import viewStyles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../../components/ToastMsg";
import { changePaymentStatus, getPaymentById } from "../../../../../redux/features/payments/paymentService";
import { useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Modal from "../../../../../components/Modal";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { NumericFormat } from "react-number-format";
import { getAllCurrencies } from "../../../../../redux/features/currency/currencyService";
import Dropdown from "../../../../../components/Dropdown/Dropdown";

const statusColors = {
    'Pending': '#FACC15',
    'Payment Approved': '#4ADE80',
    'Payment Rejected': '#F87171',
    'Invoice Created': '#60A5FA',
    'Invoice Sent': '#A78BFA',
};

const ViewPayment = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dropdownRef = useRef();

    const { isPaymentLoading, payment } = useSelector((state) => state.payment.paymentDetails);
    const { currencies } = useSelector((state) => state.currency.allCurrencies);

    const [formData, setFormData] = useState({});

    const [errorMessages, setErrorMessages] = useState({});
    const [isApproveModalOpen, setApproveModalOpen] = useState(false);
    const [isCancelModalOpen, setCancelModalOpen] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState({
        id: '',
        name: ''
    });

    const getPaymentData = async () => {
        try {
            const response = await dispatch(getPaymentById({ id })).unwrap();
            if (response.status === 'Payment Cancelled') {
                navigate('/admin/payments')
            }
            else {
                setFormData({
                    amount: response.amount,
                    exchange_rate: response.exchange_rate,
                    currency: response.currency
                });
            }
        } catch (error) {
            showToast('error', error.message);
        }
    }

    useEffect(() => {
        getPaymentData();
        dispatch(getAllCurrencies({}));
    }, [dispatch, id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const handleCurrencySelect = (option) => {
        setSelectedCurrency({
            id: option.id,
            name: option.name
        });
        setErrorMessages({ ...errorMessages, currency: '' });
    };

    const isValidPayment = () => {
        const errors = {};
        if (!formData.amount) {
            errors.amount = "Amount is required.";
        }
        if (!selectedCurrency.name || !formData.exchange_rate) {
            errors.currency = "Currency and Exchange Rate are required.";
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    };

    const confirmNewPayment = async () => {
        if (isValidPayment()) {
            setApproveModalOpen(true);
        }
    }

    const handleCancelYes = async () => {
        setCancelModalOpen(false);
        try {
            const data = {
                id: +id,
                payment_status: "Payment Rejected"
            }
            const response = await dispatch(changePaymentStatus(data)).unwrap();
            showToast('success', response.message);
            getPaymentData();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    const closeCancelModal = () => setCancelModalOpen(false);

    const handleApproveYes = async () => {
        setApproveModalOpen(false);
        try {
            const data = {
                id: +id,
                payment_status: "Payment Approved",
                amount: formData.amount,
                currency: selectedCurrency.name,
                exchange_rate: formData.exchange_rate
            }
            const response = await dispatch(changePaymentStatus(data)).unwrap();
            showToast('success', response.message);
            getPaymentData();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    const closeApproveModal = () => setApproveModalOpen(false);

    const openSlip = async () => {
        window.open(payment?.document_url, "_blank");
    }

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Payment Details</h1>
                <div className={styles.formContainer}>
                    <div className={viewStyles.paymentDetailsDiv}>
                        <div className={viewStyles.customerDetails}>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Customer Code: </p>
                                <p className={viewStyles.valueSec}>{isPaymentLoading ? <Skeleton inline width={100} /> : payment?.order?.customer.customer_code}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Name: </p>
                                <p className={viewStyles.valueSec}>{isPaymentLoading ? <Skeleton inline width={100} /> : payment?.order?.customer.full_name}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Phone Number: </p>
                                <p className={viewStyles.valueSec}>{isPaymentLoading ? <Skeleton inline width={100} /> : payment?.order?.customer.phone_number}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Email: </p>
                                <p className={viewStyles.valueSec}>{isPaymentLoading ? <Skeleton inline width={100} /> : payment?.order?.customer.email}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Method: </p>
                                <p className={viewStyles.valueSec}>{isPaymentLoading ? <Skeleton inline width={100} /> : payment?.method}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Pay Slip: </p>
                                <p className={viewStyles.valueSec} style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={openSlip}>{isPaymentLoading ? <Skeleton inline width={100} /> : `View Slip`}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Reamark: </p>
                                <p className={viewStyles.valueSec}>{isPaymentLoading ? <Skeleton inline width={100} /> : payment?.remark ? payment?.remark : '-'}</p>
                            </div>
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}>Payment Status: </p>
                                <p className={`${viewStyles.valueSec} ${viewStyles.statusLabel}`} style={{ backgroundColor: statusColors[payment?.payment_status] }}>{isPaymentLoading ? <Skeleton inline width={100} /> : payment?.payment_status}</p>
                            </div>
                        </div>
                        <div className={viewStyles.detailRow}>
                            <p className={viewStyles.titleSec}>Amount in JPY: </p>
                            {isPaymentLoading ? <Skeleton inline width={100} /> :
                                payment?.payment_status === 'Pending' ?
                                    <NumericFormat
                                        id="amount"
                                        name="amount"
                                        value={formData['amount']}
                                        thousandSeparator=","
                                        decimalSeparator="."
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        allowNegative={false}
                                        placeholder="Enter amount"
                                        className={`form-input-default ${viewStyles.payInput}`}
                                        onValueChange={(values) => {
                                            const { value } = values;
                                            handleInputChange({
                                                target: {
                                                    name: "amount",
                                                    value: value,
                                                },
                                            });
                                            setErrorMessages({ ...errorMessages, amount: '' });
                                        }}
                                    />
                                    :
                                    <p className={viewStyles.valueSec}>{payment?.amount?.toLocaleString()}</p>
                            }
                        </div>
                        {payment?.payment_status === 'Pending' &&
                            <div className={viewStyles.detailRow}>
                                <p className={viewStyles.titleSec}></p>
                                {errorMessages.amount && (
                                    <p className={`text-danger`}>{errorMessages.amount}</p>
                                )}
                            </div>
                        }
                        <div className={viewStyles.detailRow}>
                            <p className={viewStyles.titleSec}>Exchange Rate: </p>
                            {isPaymentLoading ? <Skeleton inline width={100} /> :
                                payment?.payment_status === 'Pending' ?
                                    <>
                                        <div className={viewStyles.dropDownCustom}>
                                            <Dropdown
                                                ref={dropdownRef}
                                                options={currencies}
                                                placeholder="Choose a Currency"
                                                onSelect={handleCurrencySelect}
                                                value={selectedCurrency.name}
                                                className={viewStyles.payInput}
                                            />
                                        </div>
                                        <NumericFormat
                                            id="exchange_rate"
                                            name="exchange_rate"
                                            value={formData['exchange_rate']}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            allowNegative={false}
                                            placeholder="Enter exchange rate"
                                            className={`form-input-default ${viewStyles.payInput}`}
                                            onValueChange={(values) => {
                                                const { value } = values;
                                                handleInputChange({
                                                    target: {
                                                        name: "exchange_rate",
                                                        value: value,
                                                    },
                                                });
                                                setErrorMessages({ ...errorMessages, currency: '' });
                                            }}
                                        />
                                    </>
                                    :
                                    <p className={viewStyles.valueSec}>{payment?.currency} {payment?.exchange_rate}</p>
                            }
                        </div>
                        <div className={`${viewStyles.detailRow} ${viewStyles.finalRow}`}>
                            <p className={viewStyles.titleSec}></p>
                            {errorMessages.currency && (
                                <p className={`text-danger`}>{errorMessages.currency}</p>
                            )}
                        </div>
                        {payment?.payment_status === 'Pending' &&
                            <div className={viewStyles.vehicleDetails}>
                                <button className={`btn-primary`} onClick={confirmNewPayment}>Approve Payment</button>
                                <button className={`btn-primary`} onClick={() => {
                                    setCancelModalOpen(true)
                                }} style={{ marginLeft: '10px' }}>Reject Payment</button>
                            </div>
                        }
                    </div>
                    {/* {(payment?.payment_status !== 'Pending' && payment?.payment_status !== 'Payment Rejected') &&
                        <div className={styles.vehicleFormGroup}>
                            <h1 className={`form-title`} style={{ marginTop: '20px' }}>Commercial Invoice</h1>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        {isPaymentLoading ? <Skeleton /> :
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Billing Address Line 1<span className={`required-star`}>*</span>
                                            </label>
                                        }
                                        {isPaymentLoading ? <Skeleton /> :
                                            <input
                                                type='text'
                                                id='address_line_1'
                                                name='address_line_1'
                                                value={formData.address_line_1 || ''}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                                placeholder="Enter Address"
                                            />
                                        }
                                        {errorMessages.address_line_1 && (
                                            <p className={`text-danger`}>{errorMessages.address_line_1}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        {isPaymentLoading ? <Skeleton /> :
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Billing Address Line 2<span className={`required-star`}>*</span>
                                            </label>
                                        }
                                        {isPaymentLoading ? <Skeleton /> :
                                            <input
                                                type='text'
                                                id='address_line_2'
                                                name='address_line_2'
                                                value={formData.address_line_2 || ''}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                                placeholder="Enter Address"
                                            />
                                        }
                                        {errorMessages.address_line_2 && (
                                            <p className={`text-danger`}>{errorMessages.address_line_2}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        {isPaymentLoading ? <Skeleton /> :
                                            <label htmlFor='full_name' className={`form-label`}>
                                                City<span className={`required-star`}>*</span>
                                            </label>
                                        }
                                        {isPaymentLoading ? <Skeleton /> :
                                            <input
                                                type='text'
                                                id='city'
                                                name='city'
                                                value={formData.city || ''}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                                placeholder="Enter Address"
                                            />
                                        }
                                        {errorMessages.city && (
                                            <p className={`text-danger`}>{errorMessages.city}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        {isPaymentLoading ? <Skeleton /> :
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Invoice Date<span className={`required-star`}>*</span>
                                            </label>
                                        }
                                        {isPaymentLoading ? <Skeleton /> :
                                            <input
                                                type='date'
                                                id='invoice_date'
                                                name='invoice_date'
                                                value={formData.invoice_date || ''}
                                                onChange={handleInputChange}
                                                className={`form-input-default`}
                                            />
                                        }
                                        {errorMessages.invoice_date && (
                                            <p className={`text-danger`}>{errorMessages.invoice_date}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`form-input-row`}>
                                <div className={`form-input-col md-col`}>
                                    <div className={`form-input-group`}>
                                        {isPaymentLoading ? <Skeleton /> :
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Note
                                            </label>
                                        }
                                        {isPaymentLoading ? <Skeleton /> :
                                            <textarea
                                                type='text'
                                                id='notes'
                                                name='notes'
                                                value={formData.notes || ''}
                                                onChange={handleInputChange}
                                                placeholder='Enter Note'
                                                className={`form-input-default`}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                            {payment?.invoices.length > 0 ?
                                <>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={isEditingQuotation}
                                        onClick={updateQuotation}
                                    >
                                        {isEditingQuotation ? <BeatLoader /> : `Update Invoice`}
                                    </button>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={isDownloading}
                                        onClick={() => generateInvoice(payment?.invoices[0])}
                                        style={{ marginLeft: '10px' }}
                                    >
                                        View Invoice
                                    </button>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={isStatusLoading}
                                        onClick={() => updatePaymentStatus()}
                                        style={{ marginLeft: '10px' }}
                                    >
                                        {isStatusLoading ? <BeatLoader /> : `Send Invoice`}
                                    </button>
                                </>
                                :
                                isPaymentLoading ? <Skeleton /> :
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={isQuotationCreating}
                                        onClick={submitQuotation}
                                    >
                                        {isQuotationCreating ? <BeatLoader /> : `Create Invoice`}
                                    </button>
                            }
                        </div>
                    } */}
                </div>
                {/* <PDFViewer width="100%" height="100%">
                    <CommercialInvoice  data={[payment?.invoices[0], payment]} />
                </PDFViewer> */}
            </div>
            {isApproveModalOpen && (
                <Modal
                    title='Approve Payment'
                    onClose={closeApproveModal}
                    onYes={handleApproveYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to approve the Payment?`}
                    colorType={`var(--green)`}
                />
            )}
            {isCancelModalOpen && (
                <Modal
                    title='Reject Payment'
                    onClose={closeCancelModal}
                    onYes={handleCancelYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to reject the Payment?`}
                    colorType={`var(--green)`}
                />
            )}
        </div>
    );
};

export default ViewPayment;
